import { Divider, Space, Switch, Tag, Typography } from 'antd';
import { FC } from 'react';

import { DescriptionBlock } from '@/common/components';
import { BaseQueryParams } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';

import { DomainVisitors } from '@/modules/Domains';
import { getRedirectMatchModeLabel, getRedirectSourceLabel, getRedirectTargetLabel, useGetByIdRedirectsQuery } from '@/modules/Sites';

import { RedirectsOverviewDropdown } from './RedirectsOverviewDropdown';

interface Props {
  redirect: BaseQueryParams<typeof useGetByIdRedirectsQuery>['data'];
  disableButtons: boolean;
  isDeleteRedirectLoading: boolean;
  editRedirectsIsLoading: boolean;
  handleEditRedirect: () => void;
  handleDeleteRedirect: () => void;
  handleActivateRedirect: () => void;
}

export const RedirectsOverviewView: FC<Props> = ({
  redirect,
  disableButtons,
  isDeleteRedirectLoading,
  editRedirectsIsLoading,
  handleEditRedirect,
  handleDeleteRedirect,
  handleActivateRedirect
}) => {
  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Switch checked={ redirect.isActive } disabled={ editRedirectsIsLoading } checkedChildren="Активно" unCheckedChildren="Вимкнено" onClick={ handleActivateRedirect }/>
            <Divider type="vertical"/>
            <RedirectsOverviewDropdown
              isItemsDisabled={ disableButtons }
              isDeleteRedirectLoading={ isDeleteRedirectLoading }
              handleEditRedirect={ handleEditRedirect }
              handleDeleteRedirect={ handleDeleteRedirect }
            />
          </Space>
        }
      />

      <DescriptionBlock items={ [['З', <Typography.Text key="redirect.source">{ getRedirectSourceLabel(redirect) }</Typography.Text>]] }/>

      <DescriptionBlock items={ [['На', <Typography.Text key="redirect.target">{ getRedirectTargetLabel(redirect) }</Typography.Text>]] }/>

      <DescriptionBlock items={ [['Код', <Tag key="redirect.statusCode" color="blue">{ redirect.statusCode }</Tag>]] }/>

      <DescriptionBlock items={ [['Режим', <Tag key="redirect.matchMode" color="geekblue">{ getRedirectMatchModeLabel(redirect.matchMode) }</Tag>]] }/>

      <DescriptionBlock
        items={ [[
          'Для відвідувача',
          <>
            { redirect.forVisitor === DomainVisitors.GoogleBot && <Tag color="geekblue">Google Bot</Tag> }
            { redirect.forVisitor === DomainVisitors.Any && <Tag color="geekblue">Будь-хто</Tag> }
            { redirect.forVisitor === DomainVisitors.Person && <Tag color="geekblue">Людина</Tag> }
          </>
        ]] }/>
    </>
  );
};
